// extracted by mini-css-extract-plugin
export default {"dropZone":"dropZone__CtGCD","bottomDropZone":"bottomDropZone__Y5sPv"};